import {
  View,
  StyleSheet,
  Pressable,
  ScrollView,
  Platform,
} from "react-native";
import React, { useEffect, useMemo } from "react";
import RText from "../RText";
import variables from "../../styles/variables";
import Icon from "../Icon";
import RTVGradient from "../Gradients/RTVGradient";
import {
  DrawerContentScrollView,
  useDrawerStatus,
} from "@react-navigation/drawer";
import Gap from "../Gap";
import DrawContentItem from "./DrawContentItem";
import { DrawerActions } from "@react-navigation/native";
import Socials from "../Socials";
import RtvSafeView from "../Layout/RSafeAreaView";
import { useAtom, useSetAtom } from "jotai";
import { openDrawerAtom, unreadNotificationCountAtom } from "../../atoms";
import { AppInfo } from "../AppInfo";
import { months } from "../../utils/TimeCalculator";
import useScrollGap from "../useScrollGap";
import useCmsMoreMenu from "../../hooks/useCmsMoreMenu";
import { APP_ENV } from "../../client";

const DrawerContent = ({ navigation }) => {
  const setIsDrawerOpen = useSetAtom(openDrawerAtom);
  const GRADIENT_HEIGHT = Platform.OS === "android" ? 200 : 50;
  const [unreadCount] = useAtom(unreadNotificationCountAtom);
  const scrollPosition = useScrollGap();
  // notify parent (all the way back to root app.tsx) that component
  // has flipped between open/closed
  const isDrawerOpen = useDrawerStatus() === "open";
  useEffect(() => {
    setIsDrawerOpen(isDrawerOpen);
  }, [isDrawerOpen]);

  const { moreMenuItems } = useCmsMoreMenu();

  const MemoizedDrawerContent = useMemo(() => {
    return (
      <DrawerContentScrollView
        contentContainerStyle={{ paddingTop: 0, paddingBottom: 60 }}
        style={[styles.container, { top: scrollPosition }]}
        bounces={false}
        overScrollMode="never" // Android: turn off the bounce
        stickyHeaderIndices={[0]}
      >
        <>
          {Platform.OS != "web" && (
            <View style={styles.closeButtonContainer}>
              <Pressable
                onPress={() =>
                  navigation.dispatch(DrawerActions.toggleDrawer())
                }
              >
                <Icon name="cross" size="medium" fill="palette.neutral.x0" />
              </Pressable>
            </View>
          )}
          {Platform.OS != "web" ? (
            <RTVGradient height={GRADIENT_HEIGHT} />
          ) : null}
        </>
        <ScrollView
          style={styles.scroll}
          contentContainerStyle={styles.scrollContent}
          bounces={false}
        >
          <Pressable
            onPress={() => navigation.navigate("Account")}
            style={styles.row}
          >
            <View style={styles.myAccount}>
              <View>
                <Icon
                  name="profile"
                  size="medium"
                  fill="palette.rtv.secondary"
                  notifications={unreadCount}
                />
              </View>
              <Gap size="xsmall" />
              <RText
                weight="semiBold"
                family="secondary"
                uppercase
                color="secondary"
              >
                My Account
              </RText>
            </View>
            <View style={styles.rightAlign}>
              <Icon name="chevronLightRight" size="small" />
            </View>
          </Pressable>

          <DrawContentItem
            heading="Home"
            screens={[]}
            navigation={navigation}
          />
          <DrawContentItem
            heading="Watch"
            screens={[
              { title: "Live", route: "Watch" },
              { title: "Replays", route: "Replays" },
              { title: "On Demand", route: "OnDemand" },
              { title: "Catch Up", route: "CatchUp" },
              { title: "Tv Schedule", route: "TvSchedule" },
              { title: "RTV Play Schedule", route: "RtvPlaySchedule" },
            ]}
            navigation={navigation}
          />
          <DrawContentItem
            heading="Racecards"
            screens={[
              { title: "Racecards", route: "Racecards" },
              // { title: "Antepost", route: "Antepost" },
              { title: "Today's Runners", route: "TodaysRunners" },
              { title: "Non-Runners", route: "NonRunners" },
              {
                title: "Tommorow's Runners",
                route: "TomorrowsRunners",
              },
              {
                title: "Racing Calendar",
                route: "HorseRacingCalendar",
              },
            ]}
            navigation={navigation}
          />
          <DrawContentItem
            heading="Results"
            screens={[]}
            navigation={navigation}
          />
          <DrawContentItem
            heading="Tips"
            // screens={["RTVTipsters", "AllTips", "NapOfTheDay"]}
            screens={[
              { title: "Racing TV Tipsters", route: "RTVTipsters" },
              // { title: "All Tips", route: "AllTips" },
              { title: "Nap Of The Day", route: "NapOfTheDay" },
            ]}
            navigation={navigation}
          />
          <DrawContentItem
            heading="News"
            screens={[
              { title: "All", route: "AllNews" },
              { title: "Latest", route: "Latest" },
              { title: "Highlights", route: "Highlights" },
              { title: "Columnists", route: "Columnists" },
              { title: "Most Viewed", route: "MostViewed" },
              // { title: "Stable Tours", route: "StableTours" },
            ]}
            navigation={navigation}
          />
          <DrawContentItem
            heading="Free Bets"
            screens={[]}
            navigation={navigation}
          />
          <DrawContentItem
            heading="Members"
            screens={[
              { title: "Benefits", route: "Benefits" },
              { title: "Join Offers", route: "JoinOffer" },
              { title: "RtvExtra", route: "RtvExtra" },
              { title: "Club Days", route: "ClubDays" },
              { title: "Syndicate", route: "Syndicate" },
              { title: "Magazine", route: "Magazine" },
              { title: "Rewards4Racing", route: "Rewards4Racing" },
            ]}
            navigation={navigation}
          />
          <DrawContentItem
            heading="Tracker"
            screens={[]}
            navigation={navigation}
          />
          {APP_ENV !== "production" && (
            <DrawContentItem
              heading="Chart Examples"
              screens={[
                { title: "Basic Chart", route: "BasicChart" },
                { title: "Sparkline Chart", route: "SparklineChart" },
              ]}
              navigation={navigation}
            />
          )}

          {/* {Platform.OS != "ios" && (
          <DrawContentItem
            heading="Activate Day Pass"
            screens={[]}
            navigation={navigation}
          />
        )} */}
          {/* my account was requested to be removed keep code in case of revert */}
          {/* <DrawContentItem
          heading="My Account"
          screens={[
            { title: "Account", route: "Account" },
            { title: "Change Password", route: "ResetPassword" },
            { title: "Club Days", route: "ClubDays" },
            { title: "Tracker", route: "Tracker" },
            {
              title: "Sky Subscription",
              route: "Account",
              params: { tabName: "sky-subscription" },
            },
            {
              title: "Preferences",
              route: "Account",
              params: { tabName: "preferences" },
            },
          ]}
          navigation={navigation}
        /> */}

          <DrawContentItem
            key={`drawer-content-${moreMenuItems.length}`}
            heading="More"
            screens={[
              { title: "Racecourses", route: "Racecourses" },
              {
                title: "Profiles",
                route: "IndexOrProfile",
                params: { type: "horse" },
              },

              ...moreMenuItems,
            ]}
            navigation={navigation}
          />
        </ScrollView>
        <View style={styles.socialIconsContainer}>
          <Socials />
        </View>
        <AppInfo />
      </DrawerContentScrollView>
    );
  }, [navigation, moreMenuItems, unreadCount]);

  return (
    <RtvSafeView color={variables.colors.palette.rtv.primary}>
      {MemoizedDrawerContent}
    </RtvSafeView>
  );
};

export default DrawerContent;

const { spacing, colors } = variables;

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  closeButtonContainer: {
    backgroundColor: colors.palette.rtv.primary,
    alignItems: "flex-end",
    justifyContent: "center",
    paddingRight: spacing.xsmall,
    ...Platform.select({
      ios: {
        paddingVertical: 33 / 2,
      },
      android: {
        paddingTop: 7,
        paddingBottom: 50,
      },
    }),
  },
  scroll: {
    height: "100%",
    width: "100%",
  },
  scrollContent: {
    flexGrow: 1,
  },
  rightAlign: {
    flex: 0.5,
    alignItems: "flex-end",
    justifyContent: "center",
  },
  row: {
    flexDirection: "row",
    padding: spacing.xsmall,
    borderTopWidth: 1,
    borderTopColor: colors.palette.neutral.x100,
  },
  myAccount: {
    flexDirection: "row",
    flex: 1,
    alignItems: "center",
    cursor: "pointer",
  },
  socialIconsContainer: {
    flexGrow: 1,
    // flexDirection: "row",
    justifyContent: "flex-end",
    // justifyContent: "center",
    alignItems: "center",
    paddingVertical: spacing.small,
  },
});
